var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "height": "64px",
      "width": "64px",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 64 64",
      "xml:space": "preserve",
      "fill": "#000000"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_1"
    }
  }, [_c('g', [_c('circle', {
    staticStyle: {
      "fill": "#77b3d4"
    },
    attrs: {
      "cx": "32",
      "cy": "32",
      "r": "32"
    }
  })]), _c('g', [_c('g', {
    staticStyle: {
      "opacity": "0.2"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#231f20"
    },
    attrs: {
      "d": "M52,44c0,2.2-1.8,4-4,4H16c-2.2,0-4-1.8-4-4V24c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4V44z"
    }
  })]), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0d1"
    },
    attrs: {
      "d": "M52,42c0,2.2-1.8,4-4,4H16c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4V42z"
    }
  })]), _c('g', {
    staticStyle: {
      "opacity": "0.2"
    }
  }, [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#231f20"
    },
    attrs: {
      "d": "M35.5,30.2c-1.9-2.1-5.1-2.1-7,0L13,43.2c-0.2,0.2-0.3,0.4-0.5,0.6c0.7,1.3,2,2.2,3.4,2.2h32 c1.5,0,2.7-0.9,3.4-2.2c-0.1-0.2-0.3-0.4-0.5-0.6L35.5,30.2z"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#e0e0d1"
    },
    attrs: {
      "d": "M35.5,32c-1.9-1.9-5.1-1.9-7,0L13,43.5c-0.2,0.2-0.3,0.3-0.5,0.5c0.7,1.2,2,1.9,3.4,1.9h32 c1.5,0,2.7-0.8,3.4-1.9c-0.1-0.2-0.3-0.3-0.5-0.5L35.5,32z"
    }
  })])]), _c('g', {
    staticStyle: {
      "opacity": "0.2"
    }
  }, [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#231f20"
    },
    attrs: {
      "d": "M12.6,20.2c0.7-1.3,2-2.2,3.4-2.2h32c1.5,0,2.7,0.9,3.4,2.2c-0.1,0.2-0.3,0.4-0.5,0.6l-15.4,13 c-1.9,2.1-5.1,2.1-7,0L12.6,20.2z"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M28.5,32c1.9,1.9,5.1,1.9,7,0L51,20.5c0.2-0.2,0.3-0.3,0.5-0.5c-0.7-1.2-2-1.9-3.4-1.9H16 c-1.5,0-2.7,0.8-3.4,1.9c0.1,0.2,0.3,0.3,0.5,0.5L28.5,32z"
    }
  })])])])]), _c('g', {
    attrs: {
      "id": "Layer_2"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }